import BaseAPI from "./BaseAPI";

class CommonAPI extends BaseAPI {
  constructor() {
    super();
  }

  // Filter API
  async filterAPI(pageName, pageType) {
    const req = {
      url: "filter",
      method: "POST",
      data: { pageName: pageName, ...(pageType && { pageType }) },
    };
    return await this.makeRequest(req);
  }

  // Blacklisted API
  async blacklistedAPI(pageName) {
    const queryParams = new URLSearchParams(window.location.search);
    const req = {
      url: `blacklist/blacklist_user?pageName=${pageName}&${queryParams.toString()}`,
      method: "GET",
      data: { pageName },
    };

    return await this.makeRequest(req);
  }

  async getUserPermissionAPI() {
    const req = {
      url: "user/getUserPermission",
      method: "GET",
    };
    return await this.makeRequest(req);
  }

  async fetchResourceUrlAPI(entityID, type = "agreement") {
    const req = {
      url: `doc/pdf-url?entityID=${entityID}&type=${type}`,
      method: "GET",
    };
    return await this.makeRequest(req);
  }
}

export default CommonAPI;
